import { useEffect } from "react"
import { FullScreenLoadingCover } from "@prosolve/common-components-ui"
import useDataJobs from "../../dataHooks/useDataJobs"
import EmailModal from "./EmailModal"

export default ({
  trainer,
  onClose
}) => {
  const { isLoading, composeTrainerEventReminderEmail, fetchComposeTrainerEventReminderEmail } = useDataJobs()

  useEffect(() => {
    fetchComposeTrainerEventReminderEmail({ trainer })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {
        isLoading || !composeTrainerEventReminderEmail
        ?
        <FullScreenLoadingCover />
        :
        <EmailModal email={composeTrainerEventReminderEmail} onClose={onClose} />
      }
    </>
  )
}
